// extracted by mini-css-extract-plugin
export default {"pageContainer":"style_pageContainer__M56cz","paging":"style_paging__9esPZ","pageItem":"style_pageItem__mJL9z","active":"style_active__pCDeI","arrowBtn":"style_arrowBtn__nkER4"};